import { Component, JSXElement, Show } from "solid-js"

type Props = {
    when: any;
    children: JSXElement;
}
export const P : Component<Props> = (props) => {
    return (
        <Show when={props.when}>
            <p>
                {props.children}
            </p>
        </Show>
    )
}
